<button
	[attr.aria-expanded]="isOpen()"
	[class]="cn('block w-full', className())"
	(click)="toggleCarousel()"
	aria-controls="carousel"
	type="button"
>
	<ng-content />
</button>
<div
	[class.invisible]="!isOpen()"
	(click)="toggleCarousel($event)"
	aria-hidden="true"
	class="fixed top-0 left-0 z-50 flex size-full flex-col bg-[#000]/50 px-4 py-6 sm:bottom-auto sm:block lg:px-14 xl:px-28"
	data-close-carousel="true"
	data-test-id="carousel"
	id="carousel"
>
	<div
		class="flex max-h-1/3 flex-1 flex-row-reverse items-end sm:w-auto"
		data-close-carousel="true"
	>
		<div>
			<button
				(click)="toggleCarousel()"
				aria-label="Close"
				class="mb-5 w-11 rounded-full border border-ui-100 bg-white p-3 elevation-1 hover:border-ui-125 hover:bg-ui-25 focus:border-select-100 focus:bg-white focus:shadow-item-focus focus:shadow-focus-100 focus:outline-transparent lg:mb-10"
				data-test-id="carousel__close-button"
				role="button"
				type="button"
			>
				<svg-icon
					class="fill-current"
					src="assets/icons/icon-cross.svg"
				/>
			</button>
		</div>
	</div>
	<div
		class="flex flex-row flex-wrap items-center justify-center sm:w-auto sm:flex-nowrap"
	>
		<vp-slider
			[config]="sliderConfig()"
			[itemTemplate]="imageTpl"
			[items]="slides()"
			class="mb-5 w-full grow-0 rounded sm:order-2 sm:mb-0"
		/>
		<ng-template #imageTpl let-image let-index="index">
			@if (!loadedIndexes().has(index)) {
				<svg-icon
					class="mx-auto block size-16 animate-spin text-white"
					data-test-id="loader"
					src="assets/icons/icon-spinner.svg"
				/>
			}
			<img
				[alt]="image.alt ?? ''"
				[class]="
					cn(
						!loadedIndexes().has(index) && 'invisible',
						failedIndexes().has(index) &&
							'w-full bg-ui-25 object-none',
						'mx-auto max-h-[calc(100vh-132px)] rounded'
					)
				"
				[src]="image.src | imageQuery: { height: 1152, width: 2048 }"
				[srcset]="
					(image.src | imageQuery: { height: 270, width: 480 }) +
					' 500w,' +
					(image.src | imageQuery: { height: 540, width: 960 }) +
					' 900w,' +
					(image.src | imageQuery: { height: 810, width: 1440 }) +
					' 1600w,' +
					(image.src | imageQuery: { height: 1152, width: 2048 }) +
					' 2000w'
				"
				(error)="setImageFallback(index)"
				(load)="onImageLoad(index)"
				data-test-class="carousel__image"
				height="auto"
				width="auto"
			/>
		</ng-template>
		<div class="mr-6 w-8 sm:order-1 sm:mr-7">
			@if (slides().length > 1) {
				<vp-slider-nav-button
					(pressed)="slidePrev()"
					direction="prev"
					placement="inline"
					variant="light"
				/>
			}
		</div>
		<div class="order-3 ml-6 w-8 sm:ml-7">
			@if (slides().length > 1) {
				<vp-slider-nav-button
					(pressed)="slideNext()"
					direction="next"
					placement="inline"
					variant="light"
				/>
			}
		</div>
	</div>
</div>
